import apiPlatform from "../apiPlatform";
import apiUser from "../apiUser";
import {CLIENT_COMPANY_TYPE, CLIENT_PERSON_TYPE} from "./client";

export const fetchClient = (data, onSuccess) => {
  if([CLIENT_PERSON_TYPE, CLIENT_COMPANY_TYPE].includes(data.type)){
    let q = [];
    if(data.type === CLIENT_PERSON_TYPE){
      q.push('city=' + data.city);
      q.push('postalCode=' + data.postalCode);
      q.push('street=' + data.street);
      q.push('firstname=' + data.firstname);
      q.push('lastname=' + data.lastname);
    }else if(data.type === CLIENT_COMPANY_TYPE){
      q.push('nip=' + data.nip)
    }

    apiPlatform.clients.list(q.join('&'))
      .then(res => {
        if(res.data['hydra:member'].at(-1)){
          onSuccess(res.data['hydra:member'].at(-1))
        }else{
          apiUser.clients.post(data)
            .then(client => onSuccess(client, true))
        }
      })
  }else{
    onSuccess(false)
  }



  if(data.type === CLIENT_PERSON_TYPE){

  }else if(data.type === CLIENT_COMPANY_TYPE){

  }


}
